import { render, staticRenderFns } from "./ReceiveExportDetails_Details.vue?vue&type=template&id=5184b56e&"
import script from "./ReceiveExportDetails_Details.vue?vue&type=script&lang=js&"
export * from "./ReceiveExportDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports